import { api } from "./api";
import { UsuarioResponse, ChangePassResponse } from "../types/user";

export const UsuarioService = {

// Obtener todos los usuarios (activos o inactivos)
  getAll: (activo: boolean) => {
    const url = activo !== undefined ? `/usuarios/${activo ? 1 : 0}` : "/usuarios";
    return api.get(url);
  },

  // Obtener usuario por ID
  getById: (id: number) => {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("ID debe ser un número positivo");
    }
    return api.get(`/usuarios/${id}/individual`);
  },

  // Crear usuario con validación
  crear: (data: UsuarioResponse) => {
    return api.post("/auth/register", data);
  },

  // Actualizar usuario con validación
  actualizar: (id: number, data: UsuarioResponse) => {
    return api.put(`/usuarios/${id}/actualizar`, data);
  },

  // Desactivar usuario
  desactivar: (id: number) => {
    return api.put(`/usuarios/${id}/desactivar`);
  },

  // Activar usuario
  activar: (id: number) => {
    return api.put(`/usuarios/${id}/activar`);
  },

  cambiarContrasena: (data: ChangePassResponse) => {
    return api.put(`/usuarios/perfil/cambiar-contrasena`, data);
  }
};